export default "__VITE_ASSET__ec4ea0c4__"